import React, {useEffect} from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import FormControl from "../../components/inputs/FormControl";
import {useSearchParams} from "react-router-dom";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {CalendarIcon} from "../../components/icons/MANIcons";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import useTranslation from "../../hooks/usetranslation";
import {InputAdornment, OutlinedInput} from "@mui/material";
import Typography from "@mui/material/Typography";

const AvailableDatePicker: React.FC = () => {
    const {t} = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const validityTime = searchParams.get("validityTime");

    const handleValidityChange = (value: Date | null) => {
        const params = new URLSearchParams(searchParams.toString());
        params.delete("page");
        if (value) {
            params.set("validityTime", dayjs(value).format("YYYY-MM-DDTHH:mm:ss[Z]"));
            setSearchParams(params);
        } else {
            params.delete("availableFrom");
            setSearchParams(params);
        }
    }

    //set current month and year as default
    useEffect(() => {
            const currentMonth = dayjs().format("MM");
            const currentYear = dayjs().format("YYYY");
            const params = new URLSearchParams(searchParams.toString());
            if (!params.has("validityTime")) {
                params.set("validityTime", `${currentYear}-${currentMonth}-01T00:00:00Z`);
                setSearchParams(params);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ,[])


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid item xs={12} md={12}>
                <FormControl>
                    <Typography variant="subtitle2">{t("validity_label")}</Typography>

                    <DatePicker
                        value={validityTime ? new Date(validityTime) : null}
                        onChange={handleValidityChange}
                        views={["year", "month"]}
                        inputFormat={"MM.YYYY"}
                        components={{ OpenPickerIcon: CalendarIcon }}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                            <OutlinedInput
                                inputRef={inputRef}
                                inputProps={inputProps}
                                readOnly
                                sx={{
                                    width: "100%",
                                    height: 45,
                                    backgroundColor: "white",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#ccc",
                                        borderWidth: 1,
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        padding: "4px 0 4px 8px",
                                    },
                                    "& .MuiInputAdornment-root": {
                                        marginRight: 0,
                                    },
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        {InputProps?.endAdornment}
                                    </InputAdornment>
                                }
                            />
                        )}
                    />
                </FormControl>
            </Grid>
        </LocalizationProvider>
    )
};

export default AvailableDatePicker;